import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  outlinedFieldSx,
  fieldPromptSx,
  fieldValueSx
} from "../../utils/fieldStyles";

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 150,
    width: "100%"
  }
}));

export default function SelectComponent({
  onChange,
  value,
  label,
  items
}: {
  onChange: any;
  value: string;
  label?: string;
  items: {
    label: string;
    value: number | string;
  }[];
}) {
  const classes = useStyles();
  return (
    <FormControl className={classes.formControl} sx={outlinedFieldSx}>
      <InputLabel id="demo-simple-select-standard-label" sx={fieldPromptSx}>
        {label}
      </InputLabel>
      <Select
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        value={value}
        onChange={e => onChange(e.target.value)}
        label={label}
      >
        {items.map(item => (
          <MenuItem key={`${item.value}`} value={item.value} sx={fieldValueSx}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
